import { StyledForm } from "./styled";

const Form = ({ onSubmit, maxWidth, children, ...restProps }) => (
  <StyledForm onSubmit={onSubmit} maxWidth={maxWidth} {...restProps}>
    {children}
  </StyledForm>
);

export default Form;
